import { Toast } from '@app/utils/toast'

import type { GT_Material, Import_Material, Material_Status_Log } from '../../types/materials'
import type { Action_Tab } from '../../types/wordpress-globals'
import type { GT_Term, WP_Term } from '../../types/globals'
import ClickEvent = JQuery.ClickEvent

export class Materials_Controller {
    find_material_status( status: Action_Tab, slug: string ): GT_Term|undefined {
        if ( status === 'data' ) {
            return undefined
        }

        return gt_material_status[ status ].find( ( term: WP_Term ): boolean => term.slug === slug )
    }

    find_material_completed_status( status: Action_Tab ): GT_Term|undefined {
        switch ( status ) {
            case 'planning':
                return this.find_material_status( status, 'planning-packed' )
            case 'cutting':
                return this.find_material_status( status, 'cutting-completed' )
            case 'cnc':
                return this.find_material_status( status, 'cnc-completed' )
            case 'fitting':
                return this.find_material_status( status, 'fitting-completed' )
            case 'finishing':
                return this.find_material_status( status, 'finishing-completed' )
            case 'assembly':
                return this.find_material_status( status, 'assembly-completed' )
            default:
                return undefined
        }
    }

    get_material_ordered_date( material: GT_Material ): string {
        const ordered = this.find_material_status( action_tab, 'planning-ordered' )

        if ( ! ordered || ! material.status.includes( ordered.term_id ) ) {
            return ''
        }

        const log = material.status_log.toReversed().find(
            el => ( el.action === 'add' ) && ( el.term.slug === 'planning-ordered' )
        )

        if ( ! log ) {
            return ''
        }

        return format_date( log.date )
    }
}

export class App_Materials_Controller extends Materials_Controller {
    ready() {
        console.debug( 'ready: App_Materials_Manager' )
        this.init_events()
    }

    init_events() {
        const import_previews = document.querySelector( '.import-preview-list' )
        if ( import_previews ) {
            import_previews.addEventListener(
                'click',
                ( e ) => {
                    const target = e.target as HTMLElement
                    console.log( 'clicked', target )

                    if ( target.dataset.action === 'remove-new-project-material' ) {
                        e.preventDefault()
                        console.log( 'delete project material' )
                        this.delete_new_project_material_input( target )
                    }
                }
            )
        }

        const import_materials = document.getElementById( 'project-import-materials' )
        if ( import_materials ) {
            import_materials.addEventListener(
                'change',
                ( e ) => {
                    const target = e.target as HTMLInputElement
                    console.log( 'changed', target.files )

                    const files = target.files

                    app.parse_materials_import( files )
                }
            )
        }
    }

    delete_new_project_material_input( target: HTMLElement ) {
        console.log( 'delete project material input', target )

        const el = target.closest( '.material-preview' )

        if ( el ) {
            el.remove()
        }
    }

    render_material_preview( material: Import_Material, i: number ) {
        const container = document.querySelector( '.import-preview-list' )
        const id        = Date.now() + i

        if ( ! container ) {
            return
        }

        const div = document.createElement( 'div' )
        div.classList.add( 'material-preview' )

        console.log( 'JSON', JSON.stringify( material.properties ), material.properties )

        div.innerHTML = `
			<div class="inline fields">
				<div class="eight wide field">
					<div class="ui labeled input material-type">
						<label for="project-material-types[${id}]" class="ui label"></label>
						<input type="text" class="form-control" name="project-material-types[${id}]" id="project-material-types[${id}]" placeholder="Kategorie eingeben" value="${material.type}">
					</div>
				</div>
				<div class="seven wide field">
					<input type="text" class="form-control" name="project-material-ids[${id}]" id="project-material-ids[${id}]" placeholder="ID eingeben" value="${material.id}">
				</div>
				<div class="one wide field">
					<button class="ui red icon button" data-action="remove-new-project-material">
						<i class="times icon"></i>
					</button>
				</div>
				<input type="hidden" name="project-material-names[${id}]" id="project-material-names[${id}]" value="${material.name ?? ''}">
				<input type="hidden" name="project-material-properties[${id}]" id="project-material-properties[${id}]" value='${JSON.stringify( material.properties )}'>
			</div>
			<div class="material-properties"></div>
		`

        if ( material.name ) {
            const properties = div.querySelector( '.material-properties' )

            if ( properties ) {
                properties.innerHTML = `<div class="ui small primary label">Materialart: ${material.name}</div>`
            }

        }

        if ( Object.keys( material.properties ).length ) {
            const properties = div.querySelector( '.material-properties' )

            if ( properties ) {
                for ( const key in material.properties ) {
                    if ( [ 'Fläche', 'Volumen' ].includes( key ) ) {
                        continue
                    }

                    properties.innerHTML += `<div class="ui small basic disabled label">${key}: ${material.properties[key]}</div>`
                }
            }
        }

        container.append( div )

        jQuery( '#form-project-add' ).form( 'set optional', `#material-property-titles[${id}]`, true )
        jQuery( '#form-import-material' ).form( 'set optional', `#material-property-titles[${id}]`, true )
    }
}

export class Project_Materials_Controller extends Materials_Controller {
    materials: GT_Material[]
    filter: string = 'all'

    constructor( materials: GT_Material[] = [] ) {
        super()
        this.materials = materials
    }

    ready() {
        console.debug( 'ready: Project_Materials_Manager' )

        // Testphase
        this.render_material_tabs()
        this.init_material_tabs()
        this.render_materials()

        this.init_actions()
        this.init_events()
        this.init_forms()
        this.init_calendars()
        this.init_dropdowns()
        this.init_checkboxes()
    }

    init_actions() {
        jQuery( '[data-action="expand-materials"]' ).on( 'click', () => this.expand_materials() )
        jQuery( '[data-action="collapse-materials"]' ).on( 'click', () => this.collapse_materials() )
        jQuery( '[data-action="focus-materials"]' ).on( 'click', () => this.focus_materials() )
        jQuery( '[data-action="unfocus-materials"]' ).on( 'click', () => this.unfocus_materials() )

        jQuery( '[data-action="add-material"]' ).on( 'click', () => this.init_modal_add_material() )
        jQuery( 'form [data-action="delete-material"]' ).on( 'click', ( e: ClickEvent ) => this.delete_material_confirmation( e.currentTarget ) )
        jQuery( '[data-action="delete-all-materials"]' ).on( 'click', () => this.delete_all_materials_confirmation() )

        jQuery( '[data-action="delete-material-delivery-date"]' ).on( 'click', ( e: ClickEvent ) => this.delete_material_delivery_date_confirmation( e ) )

        jQuery( '[data-action="import-material"]' ).on( 'click', () => this.init_modal_import_material() )
        jQuery( '[data-action="add-all-material-status"]' ).on( 'click', ( e ) => this.add_all_material_status_confirmation( e ) )

        jQuery( 'button[data-action="material-template"]' ).on( 'click', ( e: ClickEvent ) => this.set_material_template( e ) )
    }

    init_dropdowns() {
        jQuery( '#material-category-edit, #material-category' ).dropdown(
            {
                allowAdditions: true,
                hideAdditions: false,
            }
        )
    }

    init_checkboxes() {
        jQuery( '#form-add-all-material-status .ui.checkbox' ).checkbox(
            {
                onChange: () => {
                    const modal = app.get_modal( 'add-all-material-status-confirm' )
                    const approval_button = modal.find( '.actions button:not(.deny)' )
                    approval_button.removeClass( 'disabled' )
                }
            }
        );
    }

    init_events() {
        jQuery( '.action-container[data-post-type="material"] .item-lists' ).on(
            'click',
            ( e ) => {
                const target: HTMLElement|null = e.target.closest( '.list-item' )

                if ( target == null ) {
                    return
                }

                if ( 'debug' in e.target.dataset ) {
                    return
                }

                if ( e.target.dataset.action === 'toggle-material-status' ) {
                    this.toggle_material_status( target, e.target )
                    return
                }

                if ( e.target.dataset.action === 'update-material-delivery-date' ) {
                    this.init_modal_update_material_delivery_date( target )
                    return
                }

                if ( e.target.dataset.action === 'update-material' ) {
                    this.init_modal_update_material( target )
                    return
                }

                if ( e.target.dataset.action === 'show-material-status-log' ) {
                    this.init_modal_material_status_log( target )
                    return
                }

                if ( e.target.dataset.action === 'delete-material' ) {
                    this.delete_material_confirmation( target )
                    return
                }

                target.classList.toggle( 'collapsed' )
            }
        )

        const add_material_properties = document.querySelector( '.material-properties-add' )
        if ( add_material_properties ) {
            add_material_properties.addEventListener(
                'click',
                ( e: Event ) => {
                    const target = e.target as HTMLElement
                    console.log( 'clicked', target )

                    if ( target?.dataset.action === 'delete-material-property' ) {
                        this.delete_material_property_input( target )
                    }

                    if ( target?.dataset.action === 'add-material-property' ) {
                        this.create_add_material_property_input()
                    }
                }
            )
        }

        const edit_material_properties = document.querySelector( '.material-properties-edit' )
        if ( edit_material_properties ) {
            edit_material_properties.addEventListener(
                'click',
                ( e : Event ) => {
                    const target = e.target as HTMLElement
                    console.log( 'clicked', target )

                    if ( target?.dataset.action === 'delete-material-property' ) {
                        this.delete_material_property_input( target )
                    }

                    if ( target?.dataset.action === 'add-material-property' ) {
                        this.create_update_material_property_input()
                    }
                }
            )
        }
    }

    init_forms() {
        jQuery( '#form-import-material' ).form(
            {
                errorFocus: false,
                onSuccess: ( e: Event ) => this.ajax_import_material( e ),
                onFailure: Toast.show_invalid_form,
            }
        )

        jQuery( '#form-add-material' ).form(
            {
                fields: {
                    'material-category': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Kategorie auswählen oder hinzufügen.'
                            }
                        ]
                    },
                    'material-id': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Bezeichnung definieren.'
                            }
                        ]
                    }
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e: Event ) => this.ajax_add_material( e ),
                onFailure: Toast.show_invalid_form,
            }
        )

        jQuery( '#form-edit-material' ).form(
            {
                fields: {
                    'material-category-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Kategorie auswählen oder hinzufügen.'
                            }
                        ]
                    },
                    'material-id-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Bezeichnung definieren.'
                            }
                        ]
                    }
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e: Event ) => this.ajax_update_material( e ),
                onFailure: app.show_toast_invalid_form,
            }
        )

        jQuery( '#form-edit-material-delivery-date' ).form(
            {
                fields: {
                    'material-delivery-date-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum definieren.'
                            }
                        ]
                    }
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e: Event ) => this.ajax_update_material_delivery_date( e ),
                onFailure: app.show_toast_invalid_form,
            }
        )
    }

    init_calendars() {

        jQuery( '#date-material-delivery-date-edit' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },

                    // @ts-expect-error TODO
                    onChange: ( date, text, mode ) => {
                        console.debug( 'date-material-delivery-date-edit onchange', date, text, mode )
                    }
                }
            )
    }

    init_material_tabs() {
        console.log( 'init material tabs', this.filter )

        const tabs = jQuery( '.action-container[data-post-type="material"] .tabular.menu .item' )

        tabs.tab(
            {
                onBeforeChange: ( tab ): boolean =>  {
                    console.log( 'tab change', tab )
                    this.filter = tab
                    this.render_materials()
                    return true
                },
                onVisible: ( tab ) => {
                    console.log( 'tab changed', tab )
                },
            }
        )
    }

    set_materials( data: GT_Material[] ) {
        console.debug( 'set materials', data )
        this.materials = data
    }

    set_filter( filter: string ) {
        console.debug( 'set materials filter', filter )

        this.filter = filter
    }

    create_add_material_property_input( name = '', value = '' ) {
        console.log( 'add material property' )

        const container: Element|null = document.querySelector( '[data-modal="add-material"] .material-property-list' )

        if ( ! container ) {
            return
        }

        const id: number = Date.now()
        const fields: HTMLElement = document.createElement( 'div' )

        fields.classList.add( 'inline', 'fields', 'material-property' )
        fields.innerHTML = `
			<div class="eight wide field">
				<div class="ui labeled input">
					<label for="material-property-titles[${id}]" class="ui label">Name</label>
					<input type="text" class="form-control" name="material-property-titles[${id}]" id="material-property-titles[${id}]" placeholder="Name eingeben..." value="${name}">
				</div>
			</div>

			<div class="eight wide field">
				<div class="ui labeled input">
					<label for="material-property-values[${id}]" class="ui label">Wert</label>
					<input type="text" class="form-control" name="material-property-values[${id}]" id="material-property-values[${id}]" placeholder="Wert eingeben..." value="${value}">
				</div>

				<button type="button" class="ui red icon button" data-action="delete-material-property">
					<i class="times icon"></i>
				</button>
			</div>
		`

        container.append( fields )

        // Form Validation Fix für neue DOM Inputs
        jQuery( '#form-add-material' ).form( 'set optional', `#material-property-titles[${id}]`, true )
    }

    create_update_material_property_input( title = '', value = '', i = 0 ) {
        console.log( 'add material property' )

        const container = document.querySelector( '[data-modal="edit-material"] .material-property-list' )

        if ( ! container ) {
            return
        }

        const id        = Date.now() + i
        const fields    = document.createElement( 'div' )

        fields.classList.add( 'inline', 'fields', 'material-property' )
        fields.innerHTML = `
			<div class="eight wide field">
				<div class="ui labeled input">
					<label for="material-property-titles-edit[${id}]" class="ui label">Name</label>
					<input type="text" class="form-control" name="material-property-titles-edit[${id}]" id="material-property-titles-edit[${id}]" placeholder="Name eingeben..." value="${title}">
				</div>
			</div>

			<div class="eight wide field">
				<div class="ui labeled input">
					<label for="material-property-values-edit[${id}]" class="ui label">Wert</label>
					<input type="text" class="form-control" name="material-property-values-edit[${id}]" id="material-property-values-edit[${id}]" placeholder="Wert eingeben..." value="${value}">
				</div>

				<button type="button" class="ui red icon button" data-action="delete-material-property">
					<i class="times icon"></i>
				</button>
			</div>
		`

        container.append( fields )

        // Form Validation Fix für neue DOM Inputs
        jQuery( '#form-edit-material' ).form( 'set optional', `#material-property-titles-edit[${id}]`, true )
    }

    render_completed_material_tabs() {
        console.log( 'render completed material tabs' )

        const items = this.materials

        const container = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        const menu = container.querySelector( '.tabular.menu ' )

        if ( ! menu ) {
            return
        }

        items.sort( this.sort_material_titles )

        const categories = [ ... new Set( items.map( item => item.category.term_id ) ) ]
        const completed_term = this.find_material_completed_status( action_tab )

        if ( ! completed_term ) {
            return
        }

        for ( const category_id of categories ) {
            // console.log( 'id', category_id )

            const has_category = items.filter( item => item.category.term_id === category_id )

            const completed = has_category.filter( item => item.status.includes( completed_term.term_id ) )

            // console.log( has_category.length === completed.length, has_category, completed )

            const tab = menu.querySelector( `[data-id="${category_id}"]` )

            if ( ! tab ) {
                return
            }

            if ( has_category.length === completed.length ) {
                tab.classList.add( 'completed' )
            } else {
                tab.classList.remove( 'completed' )
            }
        }

        const term: GT_Term|undefined = this.find_material_completed_status( action_tab )
        const total = items.length
        const completed = term ? items.filter( el => el.status.includes( term.term_id ) ) : []
        const all_tab = menu.querySelector( '[data-tab="all"]' )

        if ( ! all_tab ) {
            return
        }

        if ( completed.length === total ) {
            all_tab.classList.add( 'completed' )
        } else {
            all_tab.classList.remove( 'completed' )
        }
    }

    render_material_tabs() {
        console.log( 'render material tabs' )

        const items: GT_Material[] = this.materials

        const container = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        const menu      = container.querySelector( '.tabular.menu ' )
        const lists     = container.querySelector( '.item-lists' )

        if ( ! menu || ! lists ) {
            return
        }

        if ( ! items.length ) {
            menu.innerHTML  = ''
            lists.innerHTML = ''
            return
        }

        items.sort( this.sort_material_titles )

        const categories = [ ... new Set( items.map( item => item.category.term_id ) ) ]

        console.log( 'category ids', categories.length, categories )

        menu.innerHTML  = '<a class="item" data-tab="all"><i class="check icon"></i> alle</a>'
        lists.innerHTML = '<ul class="item-list ui tab" data-tab="all"></ul>'

        for ( const category_id of categories ) {
            const data = gt_material_categories.find( el => el.value === category_id )

            if ( ! data ) {
                return
            }

            if ( data.slug === 'zusatzmaterial' ) {
                menu.innerHTML  += `<a class="item special" data-tab="${data.slug}" data-id="${category_id}"><i class="check icon"></i> ${data.name}</a>`
            } else {
                menu.innerHTML  += `<a class="item" data-tab="${data.slug}" data-id="${category_id}"><i class="check icon"></i> ${data.name}</a>`
            }

            if ( data.slug === this.filter ) {
                lists.innerHTML += `<ul class="item-list ui tab active" data-tab="${data.slug}"></ul>`
            } else {
                lists.innerHTML += `<ul class="item-list ui tab" data-tab="${data.slug}"></ul>`
            }

        }

        if ( this.filter !== 'all' ) {
            const tab = menu.querySelector( `.item[data-tab="${this.filter}"]` )

            if ( ! tab ) {
                this.filter = 'all'
            }
        }

        const active = menu.querySelector( `.item[data-tab="${this.filter}"]` )

        if ( ! active ) {
            return
        }

        console.log( 'active', active )
        active.classList.add( 'active' )

        this.render_completed_material_tabs()
    }

    render_materials() {
        console.debug( 'render materials', this.materials.length, this.filter )

        const container = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        let items: GT_Material[] = this.materials
        const count_el = container.querySelector( '.header-data .value' )!
        const list_el  = container.querySelector( `.item-list[data-tab="${this.filter}"]` )
        const total: number    = items.length
        const completed_status     = this.find_material_completed_status( action_tab )

        const completed: GT_Material[] = completed_status ? items.filter( ( el: GT_Material ): boolean => el.status.includes( completed_status.term_id ) ) : []

        console.debug( 'all materials', this.materials )

        if ( ! list_el ) {
            return
        }

        list_el.innerHTML = ''

        if ( action_tab === 'data' ) {
            count_el.innerHTML = `${total}`
        } else {
            if ( completed.length === total ) {
                count_el.innerHTML = `${total} <i class="check icon"></i>`
                count_el.classList.add( 'completed' )
            } else {
                count_el.innerHTML = `${completed.length} / ${total}`
                count_el.classList.remove( 'completed' )
            }
        }

        if ( total > 0 ) {
            items.sort( this.sort_material_titles )

            console.log( 'items before filter', items, this.filter )

            if ( this.filter !== 'all' ) {
                items = items.filter( el => el.category.slug === this.filter )
            }

            for ( const item of items ) {
                const li: HTMLElement = document.createElement( 'li' )

                li.classList.add( 'list-item', 'material-item', 'collapsed' )
                li.dataset.postId = item.post_id.toString()

                li.innerHTML = `
				<div class="item-title">
					<div class="title">${item.title}</div>
					
					<div class="content">
						<div class="comment">${item.comment}</div>
						<div class="properties"></div>
					</div>
					
					<div class="details"></div>
					
				</div>
				
				<div class="order-info"></div>
				
				<div class="item-info"></div>
				
				<div class="item-icon angle">
					<i class="angle left icon"></i>
				</div>
				
				<div class="item-actions">
					<a class="ui tiny primary button debug" href="/wp-admin/post.php?post=${item.post_id}&action=edit" 
					target="_blank" data-debug data-hidden="${( gt_user_settings.enable_debug === '1' ? 'false' : 'true' )}">Post bearbeiten</a>

					<button class="ui tiny button" data-action="update-material">
						bearbeiten
					</button>
					
					<button class="ui tiny button" data-action="update-material-delivery-date" data-hidden="true">
						Liefertermin bearbeiten
					</button>
					
					<button class="ui tiny button" data-action="show-material-status-log">
						Statusverlauf
					</button>
					
					<button class="ui red tiny button" data-action="delete-material">
						löschen
					</button>
				</div>	
				`

                // console.debug( 'material properties', Object.keys( item.properties ).length, item.properties )

                if ( action_tab === 'planning' ) {
                    const ordered = super.find_material_status( action_tab, 'planning-ordered' )

                    if ( ordered && item.status.includes( ordered.term_id ) ) {
                        const date      = this.get_material_ordered_date( item )
                        const container = li.querySelector( '.order-info' )

                        if ( ! container ) {
                            return
                        }

                        if ( date ) {
                            const span = document.createElement( 'span' )
                            span.dataset.meta = 'material-order-date'
                            span.dataset.action = 'update-material-delivery-date'

                            span.innerHTML = `
								<i class="shipping icon"></i> 
								${date}
							`

                            container.append( span )
                        }

                        if ( item.delivery_date ) {
                            const span = document.createElement( 'span' )
                            span.dataset.meta = 'material-delivery-date'
                            span.dataset.action = 'update-material-delivery-date'

                            span.innerHTML = `
								<i class="check icon"></i> 
								${format_date( item.delivery_date )}
							`

                            container.append( span )

                            const available = this.find_material_status( action_tab, 'planning-available' )
                            const packed    = this.find_material_status( action_tab, 'planning-packed' )

                            if ( ! item.status.includes( available!.term_id ) && ! item.status.includes( packed!.term_id ) ) {
                                span.dataset.tooltip  = 'voraussichtlicher Liefertermin'
                                span.dataset.position = 'right center'

                                span.classList.remove( 'secondary' )

                                span.innerHTML = `
								<i class="truck packing icon"></i> 
									${format_date( item.delivery_date )}
								`

                                li.classList.add( 'pending-order' )
                            }
                        }
                    }
                }

                if ( [ 'planning', 'debug' ].includes( action_tab ) ) {
                    const button = li.querySelector( 'button[data-action="update-material-delivery-date"]' )

                    if ( button ) {
                        button.removeAttribute( 'data-hidden' )
                    }
                }

                // Materialname (zB Eiche)
                if ( item.name ) {
                    const container = li.querySelector( '.title' )

                    if ( container ) {
                        container.innerHTML += ` <span class="ui small label">${item.name}</span>`
                    }
                }

                // Material Properties
                if ( Object.keys( item.properties ).length ) {
                    const content = li.querySelector( '.content .properties' )

                    if ( ! content ) {
                        return
                    }

                    Object.keys( item.properties ).sort()

                    for ( const prop in item.properties ) {
                        if ( [ 'Fläche', 'Volumen' ].includes( prop ) ) {
                            continue
                        }

                        const span = document.createElement( 'span' )
                        if ( [ 'Länge', 'Breite', 'Höhe', 'Stärke', 'Fertiglänge' ].includes( prop ) ) {
                            span.classList.add( 'ui', 'primary', 'large', 'label' )
                        } else {
                            span.classList.add( 'ui', 'basic', 'small', 'label' )
                        }

                        const value = item.properties[ prop ]
                        span.innerHTML = `${prop}: ${value}`
                        content.append( span )
                    }
                }

                if ( item.external_order ) {
                    const container: HTMLElement|null = li.querySelector( '.title' )

                    if ( ! container ) {
                        return
                    }

                    container.innerHTML += '<span class="ui small blue basic label">extern bestellt</span>'
                }

                // Status Buttons
                switch ( action_tab ) {
                    case 'data':
                        break
                    case 'planning':
                        this.render_material_action( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_action( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'planning-packed', 'verpackt', 'box' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        break
                    case 'cutting':
                        this.render_material_status_info( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_status_info( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'cutting-marked', 'markiert', 'check' )
                        this.render_material_action( li, 'cutting-completed', 'abgeschlossen', 'check double' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        this.set_material_status_button( item, gt_material_status.cutting, li )
                        break
                    case 'cnc':
                        this.render_material_status_info( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_status_info( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'cnc-completed', 'abgeschlossen', 'check' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        this.set_material_status_button( item, gt_material_status.cnc, li )
                        break
                    case 'fitting':
                        this.render_material_status_info( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_status_info( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'fitting-completed', 'abgeschlossen', 'check' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        this.set_material_status_button( item, gt_material_status.fitting, li )
                        break
                    case 'finishing':
                        this.render_material_status_info( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_status_info( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'finishing-completed', 'abgeschlossen', 'check' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        this.set_material_status_button( item, gt_material_status.finishing, li )
                        break
                    case 'assembly':
                        this.render_material_status_info( li, 'planning-ordered', 'bestellt', 'shipping fast' )
                        this.render_material_status_info( li, 'planning-available', 'vorhanden', 'thumbs up' )
                        this.render_material_action( li, 'assembly-completed', 'abgeschlossen', 'check' )
                        this.set_material_status_button( item, gt_material_status.planning, li )
                        this.set_material_status_button( item, gt_material_status.assembly, li )
                        break

                }

                list_el.append( li )
            }
        }
    }

    reset_material_status_button() {
        console.debug( 'render materials', this.materials.length )

        const container = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        const buttons = Array.from( container.querySelectorAll( 'button[data-status]' ) )

        for ( const button of buttons ) {
            button.classList.remove( 'green' )
        }
    }

    set_material_status_button( item: GT_Material, terms: WP_Term[], li: HTMLElement ) {
        if ( ! item.status.length ) {
            return
        }

        for ( const term_id of item.status ) {
            const term = terms.find( term => term.term_id === term_id )

            if ( ! term ) {
                continue
            }

            const button: HTMLElement | null = li.querySelector( `[data-status="${term.slug}"]` )

            if ( button ) {
                button.dataset.active = 'true'
            }
        }

    }

    render_material_action( li: HTMLElement, term_slug: string, term_name: string, icon: string = '' ) {
        const container: HTMLElement|null = li.querySelector( '.item-info' )

        if ( ! container ) {
            return
        }

        container.innerHTML += `
		<button class="ui compact icon button" data-action="toggle-material-status" data-status="${term_slug}" data-active="false">
			<i class="${icon} icon"></i> ${term_name}
		</button>
		`
    }

    render_material_status_info( li: HTMLElement, term_slug: string, term_name: string, icon: string = '' ) {
        const container: HTMLElement|null = li.querySelector( '.item-info' )

        if ( ! container ) {
            return
        }

        container.innerHTML += `
		<div class="ui compact icon button disabled" data-status="${term_slug}">
			<i class="${icon} icon"></i> ${term_name}
		</div>
		`
    }

    sort_material_titles( a: GT_Material, b: GT_Material ) {
        if ( a.title === b.title ) {
            return 0
        }

        return a.title.localeCompare( b.title, 'de', { numeric: true } )
    }

    expand_materials() {
        jQuery( '.material-item' ).removeClass( 'collapsed' )
    }

    collapse_materials() {
        jQuery( '.material-item' ).addClass( 'collapsed' )
    }

    focus_materials() {
        console.log( 'focus materials' )
        const container: HTMLElement|null = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        container.classList.add( 'focus-mode' )

        const placeholder = document.createElement( 'div' )
        placeholder.id = 'materials-placeholder'

        container.after( placeholder )

        document.body.append( container )
    }

    unfocus_materials() {
        console.log( 'unfocus materials' )
        const container: HTMLElement|null = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        container.classList.remove( 'focus-mode' )

        const placeholder:HTMLElement|null = document.querySelector( '#materials-placeholder' )

        if ( ! placeholder ) {
            return
        }

        placeholder.after( container )
        placeholder.remove()

    }

    toggle_material_status( material: HTMLElement, button: HTMLElement ) {
        console.log( 'toggle material status', material, button, button.dataset.active )

        const term = this.find_material_status( action_tab, button.dataset.status ?? '' )

        if ( ! term ) {
            return
        }

        this.disable_material_list_actions()
        this.disable_material_status_buttons()
        button.classList.add( 'loading' )

        if ( button.dataset.active === 'false' ) {
            this.ajax_add_material_status( material, term )
        } else {
            this.ajax_remove_material_status( material, term )
        }
    }

    ajax_add_material_status( material: HTMLElement, term: GT_Term ) {
        console.log( 'add material status', material, term )

        const material_id = material.dataset.postId

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'add_material_status',
            term: term,
            post_id,
            material_id,
            nonce
        }

        console.log( data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                this.enable_material_list_actions()
                this.enable_material_status_buttons()

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                const index: number = this.materials.findIndex( ( material: GT_Material ): boolean => response.material.post_id === material.post_id )
                this.materials[index] = response.material
                project.update_properties_meta( response.properties )

                this.render_completed_material_tabs()
                this.render_materials()
                project.render_approvals()
            }
        )
    }

    ajax_remove_material_status( material: HTMLElement, term: GT_Term ) {
        console.log( 'remove material status', material, term )

        const material_id: string|undefined = material.dataset.postId

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'remove_material_status',
            term: term,
            post_id,
            material_id,
            nonce
        }

        console.log( data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.dir( response )

                this.enable_material_list_actions()
                this.enable_material_status_buttons()

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                const index: number = this.materials.findIndex( ( material: GT_Material ): boolean => response.material.post_id === material.post_id )
                this.materials[index] = response.material
                project.update_properties_meta( response.properties )

                this.render_completed_material_tabs()
                this.render_materials()
                project.render_approvals()
            }
        )
    }

    disable_material_list_actions() {
        const container: HTMLElement|null = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        const buttons = Array.from( container.querySelectorAll( '.list-actions .ui.button' ) )

        for ( const button of buttons ) {
            button.classList.add( 'disabled' )
        }
    }

    enable_material_list_actions() {
        const container = document.querySelector( '.action-container[data-post-type="material"]' )

        if ( ! container ) {
            return
        }

        const buttons   = Array.from( container.querySelectorAll( '.list-actions .ui.button' ) )

        for ( const button of buttons ) {
            button.classList.remove( 'disabled', 'loading' )
        }
    }

    disable_material_status_buttons() {
        const buttons = Array.from ( document.querySelectorAll( '[data-action="toggle-material-status"]' ) )

        for ( const button of buttons ) {
            button.classList.add( 'disabled' )
        }
    }

    enable_material_status_buttons() {
        const buttons = Array.from( document.querySelectorAll( '[data-action="toggle-material-status"]' ) )

        for ( const button of buttons ) {
            button.classList.remove( 'disabled', 'loading' )
        }
    }

    add_all_material_status_confirmation( e: ClickEvent ) {
        console.log( 'add all material status?', e.currentTarget )

        const confirmation: JQuery<HTMLElement> = app.get_modal( 'add-all-material-status-confirm' )

        const options = confirmation.find( '.form input[type="radio"]' )

        if ( options.length > 1 ) {
            options.prop( 'checked', false )

            const approval_button = confirmation.find( '.actions button:not(.deny)' )
            approval_button.addClass( 'disabled' )
        }

        confirmation.modal(
            {
                onApprove: () => {
                    const checked = confirmation.find( '.form input[type="radio"]:checked' )
                    const value = checked.val() as string | undefined

                    if ( value ) {
                        this.ajax_add_all_material_status( e, value )
                    }
                }
            }
        )
        confirmation.modal( 'show' )
    }

    ajax_add_all_material_status( e: ClickEvent, slug: string ) {
        console.log( 'add all material status', slug )

        const button = e.target

        const status = this.find_material_status( action_tab, slug )

        if ( ! status ) {
            return
        }

        this.disable_material_list_actions()
        this.disable_material_status_buttons()
        button.classList.add( 'loading' )

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'add_all_material_status',
            post_id,
            term: status,
            category: this.filter,
            nonce
        }

        console.log( data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                this.enable_material_list_actions()
                this.enable_material_status_buttons()
                button.classList.remove( 'loading' )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_materials( response.materials )
                project.update_properties_meta( response.properties )

                this.render_completed_material_tabs()
                this.render_materials()

                project.render_approvals()
            }
        )
    }

    init_modal_update_material_delivery_date( target: HTMLElement ) {
        console.log( 'init modal: update material delivery date', target )

        const modal   = jQuery( '[data-modal="edit-material-delivery-date"]' )
        const form    = jQuery( '#form-edit-material-delivery-date' )
        const post_id = Number( target.dataset.postId )
        const material: GT_Material|undefined = this.materials.find( material => material.post_id === post_id )
        const calendar = jQuery( '#date-material-delivery-date-edit' )

        if ( ! material ) {
            return
        }

        // resets.
        form.form( 'reset' )

        // sets.
        calendar.calendar( 'set date', material.delivery_date ?? '' )
        form.find( 'input[name="post-id"' ).val( post_id )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    ajax_update_material_delivery_date( e: Event ) {
        console.log( 'update material delivery date', e )
        e.preventDefault()

        const form = jQuery( e.currentTarget as HTMLElement )
        const form_data = form.serialize()

        const form_buttons  = jQuery( '.form-actions button' )
        const submit_button = jQuery( '.submit', form )
        form_buttons.attr( 'disabled', 'disabled' )
        submit_button.addClass( 'loading elastic' )

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'update_material_delivery_date',
            form_data,
            post_id,
            nonce
        }

        console.log( data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                form_buttons.removeAttr( 'disabled' )
                submit_button.removeClass( 'loading elastic' )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                const index: number = this.materials.findIndex( ( material: GT_Material ): boolean => response.material.post_id === material.post_id )
                this.materials[index] = response.material
                this.render_materials()

                app.close_modals()
            }
        )
    }

    delete_material_delivery_date_confirmation( e: ClickEvent ) {
        console.log( 'delete material delivery date?' )

        const confirmation = app.get_modal( 'delete-material-delivery-date-confirm' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    this.delete_material_delivery_date( e )
                }
            }
        )
        confirmation.modal( 'show' )
    }

    delete_material_delivery_date( e: ClickEvent ) {
        console.log( 'delete material delivery date', e.currentTarget )

        const form    = jQuery( e.currentTarget.closest( 'form' ) )
        const post_id = Number( form.find( '[name="post-id"]' ).val() )

        const form_buttons  = jQuery( '.form-actions button' )
        const delete_button = jQuery( '.delete', form )
        form_buttons.attr( 'disabled', 'disabled' )
        delete_button.addClass( 'loading elastic' )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_material_delivery_date',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                form_buttons.removeAttr( 'disabled' )
                delete_button.removeClass( 'loading elastic' )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                const index = this.materials.findIndex( ( material: GT_Material ): boolean => response.material.post_id === material.post_id )
                this.materials[index] = response.material
                this.render_materials()

                app.close_modals()
            }
        )
    }

    init_modal_update_material( target: HTMLElement ) {
        console.log( 'init modal: update material', target )

        const modal    = jQuery( '[data-modal="edit-material"]' )
        const form     = jQuery( '#form-edit-material' )
        const post_id: number  = Number( target.dataset.postId )
        const material: GT_Material|undefined = this.materials.find( material => material.post_id === post_id )
        const category = jQuery( '#material-category-edit' ).closest( '.dropdown' )
        const external_order = jQuery( '#material-external-order-edit' ).closest( '.checkbox' )

        if ( ! material ) {
            return
        }

        // resets.
        form.form( 'reset' )
        this.clear_update_material_property_list()
        form.find( 'input[name="post-id"' ).val( post_id )
        external_order.checkbox( 'set unchecked' )

        // sets.
        category.dropdown( 'set selected', material.category.term_id.toString() )
        jQuery( '#material-id-edit' ).val( material.id )
        jQuery( '#material-name-edit' ).val( material.name ?? '' )
        jQuery( '#material-comment-edit' ).val( material.comment ?? '' )

        if ( material.external_order ) {
            external_order.checkbox( 'set checked' )
        }

        if ( Object.keys( material.properties ).length ) {
            let i = 0
            for ( const key in material.properties ) {
                i++
                this.create_update_material_property_input( key, material.properties[key], i )
            }
        } else {
            this.create_update_material_property_input()
        }

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    ajax_update_material( e: Event ) {
        console.log( 'update material', e.currentTarget )
        e.preventDefault()

        const form      = jQuery( e.currentTarget as HTMLElement )
        const form_data = form.serialize()

        const form_buttons  = jQuery( '.form-actions button', form )
        const submit_button = jQuery( '.submit', form )
        form_buttons.attr( 'disabled', 'disabled' )
        submit_button.addClass( 'loading elastic' )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'update_material',
            form_data,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ): void => {
                console.log( 'AJAX response', response )

                if ( response.success === false && response.data ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                form_buttons.removeAttr( 'disabled' )
                submit_button.removeClass( 'loading elastic' )

                const index = this.materials.findIndex( ( material: GT_Material ): boolean => response.post_id === material.post_id )
                this.materials[index] = response.material

                if ( response.new_term ) {
                    console.log( 'new material category', response.new_term )
                    gt_material_categories.push( response.new_term )
                    this.render_material_category_dropdowns()
                }

                this.render_material_tabs()
                this.init_material_tabs()
                this.render_materials()

                app.close_modals()
            }
        )
    }

    render_material_category_dropdowns() {
        if ( typeof gt_material_categories === 'undefined' || ! gt_material_categories.length ) {
            return
        }

        const dropdown = jQuery( '#material-category, #material-category-edit' )
        dropdown.dropdown( 'change values', gt_material_categories )
    }

    init_modal_add_material() {
        console.log( 'init modal: add material' )

        const modal  = jQuery( '[data-modal="add-material"]' )
        const form   = jQuery( 'form', modal )

        // resets.
        form.form( 'reset' )
        this.clear_add_material_property_list()
        this.create_add_material_property_input()

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    init_modal_material_status_log( item: HTMLElement ) {
        console.log( 'init modal:', 'material status log', item )

        const post_id = Number( item.dataset.postId )
        const post:  GT_Material|undefined    = this.materials.find( el => el.post_id === post_id )

        console.log( post_id, post )

        const modal = app.get_modal( 'material-status-log' )

        const container = document.querySelector( '[data-modal="material-status-log"] .status-logs' )

        if ( ! container || ! post ) {
            return
        }

        container.innerHTML = ''

        for ( const log of post.status_log ) {
            const log_item = this.render_material_status_log_item( log )
            container.append( log_item )
        }

        modal.modal( 'show' )
    }

    render_material_status_log_item( item: Material_Status_Log ): HTMLDivElement {
        const div = document.createElement( 'div' )
        div.classList.add( 'log-item' )

        const status: string = this.get_material_status_log_status( item.term )

        div.innerHTML = `
			<div class="status">
				<span class="badge status" data-project-status="${status}">${item.term.name}</span>
			</div>

			<div class="bullet"></div>

			<div class="info">
				<div><i class="calendar icon"></i>${format_date( item.date )} ${format_time( item.date )}</div>
				<div><i class="user icon"></i>${item.user.name}</div>
			</div>
		`

        if ( item.action === 'add' || item.action === 'add all' ) {
            const bullet:HTMLElement|null = div.querySelector( '.bullet' )

            if ( bullet ) {
                bullet.classList.add( 'add' )
                bullet.innerHTML = '<i class="small add icon"></i>'
            }

        }

        if ( item.action === 'remove' ) {
            const bullet = div.querySelector( '.bullet' )

            if ( bullet ) {
                bullet.classList.add( 'minus' )
                bullet.innerHTML = '<i class="small minus icon"></i>'
            }
        }

        return div
    }

    get_material_status_log_status( term: GT_Term ): string {
        switch ( term.slug ) {
            case 'planning-ordered':
            case 'planning-available':
            case 'planning-packed':
                return 'planning'
            case 'cutting-marked':
            case 'cutting-completed':
                return 'cutting'
            case 'cnc-complete':
                return 'cnc'
            case 'fitting-completed':
                return 'fitting'
            case 'finishing-completed':
                return 'finishing'
            case 'assembly-completed':
                return 'assembly'
            default:
                return ''
        }
    }

    ajax_add_material( e: Event ) {
        console.log( 'add material', e )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( e.currentTarget as HTMLElement )

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, post_id, nonce } = gt_ajax_object

        const data = {
            action: 'add_material',
            form_data: form.serialize(),
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_materials( response.materials ?? [] )
                project.update_properties_meta( response.properties )

                if ( response.new_term ) {
                    console.log( 'new material category', response.new_term )
                    gt_material_categories.push( response.new_term )
                    this.render_material_category_dropdowns()
                }

                this.render_material_tabs()
                this.init_material_tabs()
                this.render_materials()

                project.render_approvals()

                app.close_modals()
            }
        );
    }

    set_material_template( e: ClickEvent ): void {
        console.log( 'set material template', e.currentTarget )
        e.preventDefault()

        const button = e.currentTarget as HTMLButtonElement

        const material_category = jQuery( '#material-category' )

        const list: HTMLElement|null = document.querySelector( '.material-properties-add .material-property-list' )

        if ( ! list ) {
            return
        }

        list.innerHTML = ''
        this.create_add_material_property_input( 'Anzahl' )

        switch ( button.dataset.template ) {
            case 'a': {
                const term = gt_material_categories.find( el => el.slug === 'zusatzmaterial' )

                if ( term ) {
                    material_category.dropdown( 'set selected', term.value.toString() )
                }

                break
            }

        }

        Toast.show( `Vorlage <strong>${button.innerText}</strong> wurde angewendet.`, 'info' )
    }

    delete_material_property_input( target: HTMLElement ): void {
        console.log( 'delete material property input', target )

        const property: HTMLElement|null = target.closest( '.material-property' )

        if ( ! property ) {
            return
        }

        property.remove()
    }

    clear_add_material_property_list(): void {
        const container: HTMLElement|null = document.querySelector( '[data-modal="add-material"] .material-property-list' )

        if ( ! container ) {
            return
        }

        container.innerHTML = ''
    }

    clear_update_material_property_list() {
        const container: HTMLElement|null = document.querySelector( '[data-modal="edit-material"] .material-property-list' )

        if ( ! container ) {
            return
        }

        container.innerHTML = ''
    }

    clear_import_material_preview_list() {
        const container:HTMLElement|null = document.querySelector( '.import-preview-list' )

        if ( ! container ) {
            return
        }

        container.innerHTML = ''
    }

    delete_material_confirmation( target: HTMLElement ) {
        console.log( 'delete material?', target )

        let post_id
        const form = target.closest( 'form' ) as HTMLElement

        if ( target.nodeName === 'LI' ) { // aus der Liste
            post_id = target.dataset.postId
        } else { // aus dem Modal.
            const container = jQuery( form )
            post_id = container.find( '[name="post-id"]' ).val() as string
        }

        console.log( 'post-id', target, post_id )

        if ( ! post_id ) {
            return
        }

        const confirmation = app.get_modal( 'delete-material-confirm' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved', post_id )
                    this.ajax_delete_material( post_id )
                }
            }
        )
        confirmation.modal( 'show' )
    }

    delete_all_materials_confirmation() {
        console.log( 'delete materials?' )

        const confirmation = app.get_modal( 'delete-all-materials-confirmation' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    this.ajax_delete_all_materials()
                }
            }
        )
        confirmation.modal( 'show' )
    }

    ajax_delete_all_materials() {
        console.log( 'delete all materials' )

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_all_materials',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_materials( response.materials ?? [] )
                project.update_properties_meta( response.properties )

                this.render_material_tabs()
                this.init_material_tabs()
                this.render_materials()

                project.render_approvals()
            }
        )
    }

    ajax_delete_material( post_id: string ) {
        console.log( 'delete material', post_id )

        if ( ! post_id ) {
            return
        }

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_material',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                this.set_materials( response.materials ?? [] )
                project.update_properties_meta( response.properties )

                this.render_material_tabs()
                this.init_material_tabs()
                this.render_materials()

                project.render_approvals()
            }
        )
    }

    init_modal_import_material() {
        console.log( 'init modal: import material' )

        const modal = jQuery( '[data-modal="import-material"]' )
        const form  = jQuery( 'form', modal )

        // resets.
        form.form( 'reset' )
        this.clear_import_material_preview_list()

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    ajax_import_material( e: Event ) {
        console.log( 'import material', e )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( e.currentTarget as HTMLElement )

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, post_id, nonce } = gt_ajax_object

        const data = {
            action: 'import_material',
            form_data: form.serialize(),
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                gt_material_categories = response.terms

                this.set_materials( response.materials ?? [] )
                project.update_properties_meta( response.properties )

                this.render_material_tabs()
                this.init_material_tabs()
                this.render_materials()
                this.render_material_category_dropdowns()

                project.render_approvals()


                app.close_modals()
            }
        )
    }
}
